export const ESIM_ACTIVATION_CODE_REQUEST = 'ESIM_ACTIVATION_CODE_REQUEST';
export const ESIM_ACTIVATION_CODE_SUCCESS = 'ESIM_ACTIVATION_CODE_SUCCESS';
export const ESIM_ACTIVATION_CODE_ERROR = 'ESIM_ACTIVATION_CODE_ERROR';

export const ESIM_ACTIVATION_CODE_RESET = 'ESIM_ACTIVATION_CODE_RESET';

export const ESIM_RETRIGGER_MULTI_RECP_REQUEST = 'ESIM_RETRIGGER_MULTI_RECP_REQUEST';
export const ESIM_RETRIGGER_MULTI_RECP_SUCCESS = 'ESIM_RETRIGGER_MULTI_RECP_SUCCESS';
export const ESIM_RETRIGGER_MULTI_RECP_ERROR = 'ESIM_RETRIGGER_MULTI_RECP_ERROR';

export const SIM_ACTIVATION_STATUS_REQUEST = "SIM_ACTIVATION_STATUS_REQUEST";
export const SIM_ACTIVATION_STATUS_SUCCESS = "SIM_ACTIVATION_STATUS_SUCCESS";
export const SIM_ACTIVATION_STATUS_ERROR = "SIM_ACTIVATION_STATUS_ERROR";

export const SIM_ACTIVATION_SUBMIT_REQUEST = "SIM_ACTIVATION_SUBMIT_REQUEST";
export const SIM_ACTIVATION_SUBMIT_SUCCESS = "SIM_ACTIVATION_SUBMIT_SUCCESS";
export const SIM_ACTIVATION_SUBMIT_ERROR = "SIM_ACTIVATION_SUBMIT_ERROR";
